module.exports = __webpack_public_path__ + "static/media/cnito_livestream_play.022c75cd.png";